import qs from 'qs';

export default function paramify(paramObject) {
  return qs.stringify(paramObject, { arrayFormat: 'repeat', delimiter: '&' });
}